import React, { useEffect } from "react";
import { useLazyGetPageQuery } from "../../../redux/actions/Customer/FooterCustomer";
import { LegalPageLayout } from "../../../components/customer/LegalPageLayout";

export const ShippingPolicyScreen: React.FC = () => {
  const [triggerGetPage, { data: response, isLoading, isError }] =
    useLazyGetPageQuery();

  useEffect(() => {
    triggerGetPage(6); // WebsitePageType.ShippingPolicy = 6
  }, [triggerGetPage]);

  return (
    <LegalPageLayout
      title="Shipping Policy"
      subtitle="Learn about our delivery times and shipping rules."
      isLoading={isLoading}
      isError={isError}
      contentData={response?.value?.data || null}
    />
  );
};
export default ShippingPolicyScreen;
